import { createSlice } from '@reduxjs/toolkit';
import { Manufacturer } from '../types/manufacturer';
import { Pagination } from '../types/pagination';
import type { PayloadAction } from '@reduxjs/toolkit';
import { getManufacturersApi, createManufacturersApi, updateManufacturersApi } from '../services/manufacturers/manufacturers';
import { setAlert } from './commonSlice';
import { createQuery } from '../utils/constants';

interface InitialState {
  manufacturers: Manufacturer[];
  pagination: Pagination | null;
  prevPage: string | null;
  nextPage: string | null;
  filter: Filter;
  loader: boolean;
  saveLoader: boolean;
  selectedManufacturer: Manufacturer | null;
  manufacturersMapping: any;
}

interface Filter {
  limit: number | null;
}

const initialState: InitialState = {
  manufacturers: [],
  pagination: null,
  prevPage: null,
  nextPage: null,
  filter: {
    limit: null,
  },
  loader: false,
  saveLoader: false,
  selectedManufacturer: null,
  manufacturersMapping: [],
};

export const manufacturerSlice = createSlice({
  name: 'manufacturer',
  initialState,
  reducers: {
    getManufacturers: (state, action: PayloadAction<any>) => {
      state.manufacturers = action.payload.manufacturers;
    },
    setManufacturers: (state, action: PayloadAction<any>) => {
      state.manufacturers = action.payload;
      state.manufacturersMapping =
        action.payload?.length > 0 ? Object.fromEntries(action.payload.map((item: any) => [item.id, item])) : {};
    },
    setPagination: (state, action: PayloadAction<Pagination>) => {
      state.pagination = action.payload;
    },
    setFilter: (state, action: PayloadAction<any>) => {
      state.filter = action.payload;
    },
    setLoader: (state, action: PayloadAction<any>) => {
      state.loader = action.payload;
    },
    setSaveLoader: (state, action: PayloadAction<any>) => {
      state.saveLoader = action.payload;
    },
    setManufacturer: (state, action: PayloadAction<any>) => {
      state.selectedManufacturer = action.payload;
    },
  },
});

export const { getManufacturers, setManufacturers, setPagination, setFilter, setLoader, setSaveLoader, setManufacturer } =
  manufacturerSlice.actions;
export default manufacturerSlice.reducer;

export const getProductManufacturers = (payload: any) => async (dispatch: any, getState: any) => {
  try {
    dispatch(setLoader(true));
    const { filter } = getState().manufacturer;
    const queryParams = { ...filter, ...payload };
    const query = '?' + createQuery({ filter: queryParams });

    const response = await getManufacturersApi(query);
    if (response.kind === 'ok') {
      const { pagination, data: list } = response.data;

      dispatch(setManufacturers(list));
      dispatch(setPagination(pagination));
    }
  } catch (error) {
  } finally {
    dispatch(setLoader(false));
  }
};

export const getProductManufacturer = (payload: Manufacturer | null) => async (dispatch: any, getState: any) => {
  dispatch(setManufacturer(payload));
};

export const createProductManufacturers = (payload: any, cb?: any) => async (dispatch: any) => {
  try {
    dispatch(setSaveLoader(true));
    const result = await createManufacturersApi(payload);
    if (result?.kind === 'ok') {
      dispatch(setAlert('Manufacturer has been created successfully', 'success'));
      cb?.(null, true);
    } else {
      /*Toast.show({
        type: 'error',
        text1: 'Failed',
        text2: 'Failed to create address',
      });*/
    }
  } catch (err) {
  } finally {
    dispatch(setSaveLoader(false));
  }
};

export const updateProductManufacturers = (manufacturerId: any, payload: any, cb?: any) => async (dispatch: any) => {
  try {
    dispatch(setSaveLoader(true));
    const result = await updateManufacturersApi(manufacturerId, payload);
    if (result?.kind === 'ok') {
      dispatch(setAlert('Manufacturer has been updated successfully', 'success'));
      cb?.(null, true);
    } else {
      /*Toast.show({
        type: 'error',
        text1: 'Failed',
        text2: 'Failed to create address',
      });*/
    }
  } catch (err) {
  } finally {
    dispatch(setSaveLoader(false));
  }
};

export const applyFilter = (payload: any) => async (dispatch: any, getState: any) => {
  return dispatch(setFilter(payload));
};
